module.exports = __webpack_public_path__ + "asana.2f429b.svg";